import React, { useState, useEffect } from "react";
import Snackbar from "@material-ui/core/Snackbar";
import { Alert } from "@material-ui/lab";
import {
  CheckCircleOutline,
  ReportProblemOutlined,
  ErrorOutline,
} from "@material-ui/icons";
import useStyles from "./styles";
import { toLower, startCase } from "lodash";
import { useRecoilValue } from "recoil";
import { toastState } from "../../recoil/Toast/atom";
import { useToast } from "../../hooks/useToast";
import { isNumber } from "util";
import { createBrowserHistory } from "history";
import TargetCompletion from "Components/confettiAnimation/TargetCompletion";


export const ToastWidget = () => {
  const classes = useStyles();
  const toaster = useToast();
  const history = createBrowserHistory();
  const [showAnimation, setShowAnimation] = useState(false);
  const toast = useRecoilValue(toastState);

  useEffect(() => {
    if (toast?.showAnimation) {
      setShowAnimation(toast?.showAnimation);
    }
  }, [toast?.showAnimation]);

  const [state] = useState({
    vertical: "top",
    horizontal: "right",
  });

  const { vertical, horizontal } = state;

  const header = () => {
    let headerText = startCase(toLower(toast.type));

    if (toast.errorsCount && isNumber(toast.errorsCount)) {
      headerText = `${toast.errorsCount} ${startCase(toLower(toast.type))}`;
      if (toast.errorsCount > 1) headerText += "s";
    }

    return <h6 className={`${classes.msgTitle} truncate-txt`}>{headerText}</h6>;
  };

  useEffect(() => {
    // clear alert on location change
    return history.listen(toaster.clear);

    // stop the listener when component unmounts
    // return unlisten;
  }, []);

  if (!toast) return null;

  return (
    <div className={classes.toastWidget}>
      <Snackbar
        className={classes.toastMsg}
        anchorOrigin={{ vertical, horizontal }}
        open={true}
        onClose={toaster.clear}
        autoHideDuration={toast.duration ? toast.duration : 6000}
        key={vertical + horizontal}
      >
        <Alert
          onClose={toaster.clear}
          severity={toast.type}
          iconMapping={{
            success: <CheckCircleOutline />,
            error: <ReportProblemOutlined />,
            warning: <ErrorOutline />,
          }}
        >
          {header()}
          <span className="multi-wrap-2">{toast.message}</span>
        </Alert>
      </Snackbar>
      {showAnimation ? (
        <TargetCompletion open={showAnimation} setOpen={setShowAnimation} />
      ) : null}
    </div>
  );
};

export default ToastWidget;
